<template>
  <div>
    <Head :title="`${form.name}`" />
    <button class="bg-sky-700 text-white rounded p-2 mr-2" @click="back()">
        <i class="fa fa-arrow-left"></i>
      </button>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Clientes</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }} (${{form.balance}})
    </h1>

    <div v-if="auth.user.role != 'sales'" class="max-w-full bg-white rounded-xl shadow overflow-hidden">
      <div class="flex items-center px-8 py-4 bg-sky-700 text-white border-t border-gray-100">
        Actualizar cliente
      </div>
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre y Apellido" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Correo electrónico" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Teléfono" />
          <text-input v-model="form.identification" :error="form.errors.identification" class="pb-8 pr-6 w-full lg:w-1/2" label="Cédula o RIF" />
          <text-input v-model="form.companyName" :error="form.errors.companyName" class="pb-8 pr-6 w-full lg:w-1/2" label="Empresa" />
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Dirección" />
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label for="">Tipo de cliente</label>
            <select v-model="form.typeClient" class="w-full mt-2 form-input">
              <option value="">Seleccionar</option>
              <option value="freelancer">Freelancer</option>
              <option value="spot">SPOT</option>
              <option value="a">A</option>
              <option value="b">B</option>
              <option value="c">C</option>
            </select>
          </div>
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label for="">Vendedor</label>
            <select v-model="form.responsable_id" class="form-input mt-2 w-full">
              <option value="">Seleccionar</option>
              <option v-for="vendor in vendors" :key="vendor.id" :value="vendor.user.id">{{vendor.user.first_name}} {{vendor.user.last_name}}</option>
            </select>
          </div>
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label for="">Crédito</label>
            <input v-model="form.credit" type="checkbox" class="mt-2" />
          </div>
          <text-input v-model="form.term_credit" :error="form.errors.term_credit" class="pb-8 pr-6 w-full lg:w-1/2" label="Termino de crédito" />
          <text-input v-model="form.limit_credit" :error="form.errors.limit_credit" class="pb-8 pr-6 w-full lg:w-1/2" label="Limite de crédito" />

          <text-input v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full lg:w-1/2" label="Descuento (%)" />

        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Actualizar clientes</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    client: Object,
    organizations: Array,
    orders: Array,
    vendors: Array,
    auth: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.client.name,
        email: this.client.email,
        phone: this.client.phone,
        identification: this.client.identification,
        companyName: this.client.companyName,
        address: this.client.address,
        balance: this.client.balance,
        typeClient: this.client.typeClient,
        credit: this.client.credit,
        term_credit: this.client.term_credit,
        limit_credit: this.client.limit_credit,
        discount: this.client.discount,
        responsable_id: this.client.responsable_id
      }),
    }
  },
  methods: {
    back() {
      window.history.back();
    },
    update() {
      this.form.put(`/clients/${this.client.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this client?')) {
        this.$inertia.delete(`/clients/${this.client.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this client?')) {
        this.$inertia.put(`/clients/${this.client.id}/restore`)
      }
    },
  },
}
</script>
